import _ from 'lodash'
import jwt from 'jsonwebtoken'
import { IhmIdentityBrokerTokenProvider } from '@api/utils/IhmIdentityBrokerTokenProvider'
import { IhmIdentityBrokerServiceClient } from '@api/IhmIdentityBrokerServiceClient'
import { getSelectedTool } from '@atredux/selectors/toolSelector'
import { store } from '@atredux/store'
import { UnsupportedActionException, EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import { TokenRetrieverAllowedToolsList } from '@utils/Constants/TokenRetrieverAllowedToolsList'
import { AtCoreServiceClient } from '@api/AtCoreServiceClient'

/**
 * Cross Frame listener that provides the access to IhmLogin token to certain tools.
 * This listener checks for the current tool loaded in the Iframe and if the tool is allowListed,
 * it returns the IhmLogin token to the tool. Currently, it returns IhmLogin access token and
 * IhmLogin Open Id Token.
 *
 * @returns if the tools is authorized, it returns the tokens, else throws an error.
 */
export async function fetchIhmIdentityBrokerTokens () {
    const currentTool = getSelectedTool(store.getState())

    if (!TokenRetrieverAllowedToolsList || !_.includes(TokenRetrieverAllowedToolsList, currentTool.toolName)) {
        return Promise.reject(new UnsupportedActionException({
            message: 'Access Denied. The tool is not allowed to make this request.',
        }))
    }

    return Promise.resolve({
        tokenType: IhmIdentityBrokerTokenProvider.getTokenType(),
        refreshToken: IhmIdentityBrokerTokenProvider.getRefreshToken(),
        idToken: IhmIdentityBrokerTokenProvider.getIdToken(),
    })
}

export async function optionallyRefreshTokens () {
    const decoded = jwt.decode(IhmIdentityBrokerTokenProvider.getIdToken(), { complete: true })
    const expiry = decoded.payload.exp

    // If expiry epoch is less than epoch time in seconds right now
    if (expiry < Math.ceil(Date.now() / 1000)) {
        await IhmIdentityBrokerServiceClient.refreshTokens()
    }

    return Promise.resolve({
        tokenType: IhmIdentityBrokerTokenProvider.getTokenType(),
        refreshToken: IhmIdentityBrokerTokenProvider.getRefreshToken(),
        idToken: IhmIdentityBrokerTokenProvider.getIdToken(),
    })
}

export async function fetchIhmIdentityBrokerEncryptedToken () {
    try {
        console.log('ATBase: fetchIhmIdentityBrokerEncryptedToken call for store : ', EnvironmentDetail.getStoreId())
        return AtCoreServiceClient.getInstance().getEncryptedToken(EnvironmentDetail.getStoreId())
            .then((response) => {
                console.log('ATBase: fetchIhmIdentityBrokerEncryptedToken response', response)
                return Promise.resolve(response.body ? { encryptedToken: response.body.encryptedToken } : response)
            })
            .catch((error) => {
                console.error('ATBase: Error detected when calling getEncryptedToken in coreService: ', JSON.stringify(error))
                return Promise.reject(error)
            })
    } catch (e) {
        console.log('ATBase: fetchIhmIdentityBrokerEncryptedToken error. ', e)
        return Promise.reject(e)
    }

}
